; (function () {
    var
        $wrapper = null,

        _tbl = null,

        //
        // init 
        //
        init = function () {
            $wrapper = $('.layout-admin-clients');
            $.fn.dataTable.ext.errMode = 'none';

            if ($wrapper.length > 0) {
                setupDataTable();
            }
        },

        ctrlResetButton = function () {
            let e = document.createElement('div');
            e.classList.add('dt-search');
            e.innerHTML = `<button id="btnResetClientsTable" class="btn btn-primary btn-sm">Reset</button>`;
            return e;
        },

        setupResetBtn = function () {
            $('#btnResetClientsTable').click(function () {
                $('#adminClientsDataTable').DataTable().search('').order([[0, 'asc']]).draw();
            });
        },

        setupDataTable = function () {
            if (DataTable.isDataTable('#adminClientsDataTable')) {
                new DataTable.Api('#adminClientsDataTable').ajax.reload();
                return;
            }

            _tbl = $('#adminClientsDataTable').DataTable({
                layout: {
                    topStart: null,
                    topEnd: null,
                    bottomStart: null,
                    bottomEnd: null,
                    top: ['search', 'pageLength'],
                    bottom: ['info', 'paging'],
                },
                language: { search: "" },
                pageLength: 25,
                processing: true,
                serverSide: true,
                orderMulti: false,
                ajax: {
                    url: '/admin/client/search',
                    method: 'post',
                    dataType: 'json',
                    dataSrc: 'data',
                    data: function (d) {
                        d.includeInactive = $('#IncludeInactive').is(':checked');
                    }                    
                },
                initComplete: function () {
                    setupClientActions();
                    setupResetBtn();
                    setupIncludeInactive();
                    setupEditClient();
                },
                columnDefs: [
                    { orderSequence: ["asc", "desc"], targets: [0, 1, 2, 4] },
                    { orderSequence: ["desc", "asc"], targets: [3, 5, 6] }
                ],
                order: [[0, "asc"]],
                columns: [
                    {
                        title: 'Code',
                        data: 'clientCode',
                        name: 'ClientCode',
                        width: '15%',
                        render: function (data, type, row) {
                            return `<a href='/client/adminclient?clientID=${row.id}' style='${!row.active ? "color:#ea1b66" : ""}'>${data}</a>`;
                        }
                    },
                    {
                        title: 'Company Name',
                        data: 'clientName',
                        name: 'ClientName',
                        width: '25%'
                    },
                    {
                        title: 'Status',
                        data: 'dataStatus',
                        name: 'DataStatus',
                        className: 'dt-center',
                        width: '10%'
                    },
                    {
                        title: 'Reports',
                        data: 'reportCount',
                        name: 'ReportCount',
                        className: 'dt-center',
                        width: '10%',
                        type: 'num'
                    },
                    {
                        title: 'Products',
                        data: 'products',
                        name: 'Products',
                        width: '20%',
                        render: function (data, type, row) {
                            return data ? data.split(", ").join("<br />") : "";
                        }
                    },
                    {
                        title: 'Active',
                        data: 'active',
                        name: 'Active',
                        className: 'dt-center',
                        width: '12%',
                        render: function (data, type, row) {
                            return (data ? "Active" : "Inactive");
                        }
                    },

                    {
                        title: 'Modified',
                        data: 'modified',
                        name: 'Modified',
                        className: 'dt-center',
                        width: '12%',
                        render: function (data, type, row) {
                            if (data) {
                                var date = new Date(data);
                                return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
                            }
                            return '';
                        }
                    },
                    {
                        title: 'Actions',
                        data: null,
                        orderable: false,
                        className: 'dt-center',
                        width: '6%',
                        render: function (data, type, row) {
                            return `
                                <div class="btn-group" role="group">
                                    <a href="#" class="btn btn-sm btn-primary border-0 lnk-assign-users"
                                       data-client-id="${row.id}" 
                                       data-client-name="${row.clientName}"
                                       title="Assign Users">
                                        <i class="fa fa-users text-light"></i>
                                    </a>
                                    <a href="#" class="btn btn-sm btn-primary border-0 lnk-assign-products" 
                                       data-client-id="${row.id}" 
                                       data-client-name="${row.clientName}"
                                       title="Assign Products">
                                        <i class="fa fa-cube text-light"></i>
                                    </a>
                                    <a href="#" class="btn btn-sm btn-primary border-0 lnk-edit-client" 
                                       data-client-id="${row.id}" 
                                       title="Edit Client">
                                        <i class="fa fa-pencil text-light"></i>
                                    </a>
                                </div>
                            `;
                        }
                    }
                ]
            });

            // Style the search box
            let $searchBox = $wrapper.find('#dt-search-0');
            $searchBox.attr('placeholder', 'Search ...').addClass('form-control form-control-sm ms-0 me-1');
            $searchBox.wrap("<div style='display: inline-flex; align-items: center;'></div>");
            $searchBox.after(ctrlResetButton());
        },

        setupClientActions = function () {
            // User assignment link
            $(document).on('click', '.lnk-assign-users', function (e) {
                e.preventDefault();
                var clientId = $(this).data('client-id');
                var clientName = $(this).data('client-name');

                delta.ajax.get(`/admin/client/users?clientID=${clientId}`, function (html) {
                    delta.popup.open({
                        type: 'alert',
                        title: `User Assignment - ${clientName}`,
                        content: html,
                        css: 'client-users-popup modal-lg',
                        afterOpen: function ($popup) {
                            setupUserAssignmentActions($popup, clientId);
                        }
                    });
                });
            });

            // Product assignment link
            $(document).on('click', '.lnk-assign-products', function (e) {
                e.preventDefault();
                var clientId = $(this).data('client-id');
                var clientName = $(this).data('client-name');

                delta.ajax.get(`/admin/client/products?clientID=${clientId}`, function (html) {
                    delta.popup.open({
                        type: 'confirm',
                        title: `Product Assignment - ${clientName}`,
                        content: html,
                        css: 'client-products-popup modal-lg',
                        okButtonText: 'Save',
                        okCallback: function (p) {
                            const products = [], cbxs = document.getElementsByClassName('cbx-product');
                            Array.from(cbxs).forEach(cbx => {
                                products.push({ id: cbx.dataset.productId, hasProduct: cbx.checked });
                            });
                            delta.ajax.post(`/admin/client/products?clientID=${clientId}`, products, function (res) {
                                if (res.ok) {
                                    $('#adminClientsDataTable').DataTable().ajax.reload(); // reload table
                                    delta.popup.close(p);
                                }
                                else alert(`Error updating client products: ${res.msg}`);
                            });
                        }
                    });
                });
            });
        },


        setupUserAssignmentActions = function ($popup, clientId) {
            // Remove existing event handlers to prevent multiple bindings
            $popup.off('click', '.lnk-remove-user');
            $popup.off('click', '.lnk-add-user');
            $popup.off('click', '#btnSearchUsers');
            $popup.off('keydown', '#userSearchBox');

            // Remove user from client
            $popup.on('click', '.lnk-remove-user', function (e) {
                e.preventDefault();
                var userId = $(this).data('user-id');
                var userName = $(this).data('user-name');

                var formData = new FormData();
                formData.append('userID', userId);
                formData.append('clientID', clientId);

                delta.ajax.postFormData('/admin/client/user-remove', formData,
                    function (result) {
                        if (result.ok) {
                            // Reload the popup content
                            delta.ajax.get(`/admin/client/users?clientID=${clientId}`, function (html) {
                                $popup.find('.modal-body').html(html);
                                setupUserAssignmentActions($popup, clientId);
                            });
                        } else {
                            alert('Error removing user: ' + result.error);
                        }
                    }
                );
            });

            // Add user to client
            $popup.on('click', '.lnk-add-user', function (e) {
                e.preventDefault();
                var userId = $(this).data('user-id');
                var userName = $(this).data('user-name');

                // Try using FormData like other parts of the app
                var formData = new FormData();
                formData.append('userID', userId);
                formData.append('clientID', clientId);

                delta.ajax.postFormData('/admin/client/user-assign', formData,
                    function (result) {
                        console.log('Add user result:', result);
                        console.log('Result.ok:', result.ok);
                        if (result.ok) {
                            console.log('Success - reloading popup content');
                            // Reload the popup content
                            delta.ajax.get(`/admin/client/users?clientID=${clientId}`, function (html) {
                                console.log('Popup content reloaded');
                                $popup.find('.modal-body').html(html);
                                setupUserAssignmentActions($popup, clientId);
                            });
                        } else {
                            console.log('Error result:', result.error);
                            alert('Error adding user: ' + result.error);
                        }
                    },
                    function (error) {
                        console.error('AJAX error:', error);
                        alert('Network error occurred while adding user');
                    }
                );
            });

            // Search users functionality
            $popup.on('click', '#btnSearchUsers', function (e) {
                e.preventDefault();
                var searchValue = $popup.find('#userSearchBox').val();

                delta.ajax.get(`/admin/client/users?clientID=${clientId}&search=${encodeURIComponent(searchValue)}`, function (html) {
                    $popup.find('.modal-body').html(html);
                    setupUserAssignmentActions($popup, clientId);
                });
            });

            // Enter key search
            $popup.on('keydown', '#userSearchBox', function (e) {
                delta.ajax.get(`/admin/client/users?clientID=${clientId}&search=${encodeURIComponent(e.target.value)}&tableOnly=true`, function (html) {
                    document.getElementById('availableUsersContainer').outerHTML = html;
                    setupUserAssignmentActions($popup, clientId);
                });
            });
        },


        setupIncludeInactive = function() {
            //add include inactive
            let $controlRow = $wrapper.find('.dt-layout-full').first();

            $controlRow.find('.dt-length').before(`
                <div class="include-inactive-control flex-fill text-center">
                    <label class="form-check-label mb-0">
                        <input class="form-check-input me-1" type="checkbox" id="IncludeInactive">
                        Include inactive
                    </label>
                </div>
            `);

            //handler for include inactive checkbox
            $wrapper.on('change', '#IncludeInactive', function() {
                _tbl.ajax.reload();
            });
        },

        //
        // Edit client link & popup
        //
        setupEditClient = function() {
            $wrapper.on('click', '.lnk-edit-client', function() {
                var client_id = $(this).attr('data-client-id');

                delta.ajax.get(
                    '/admin/client/edit?clientID=' + client_id,
                    function(html) {
                        delta.popup.open({
                            type: 'confirm',
                            title: 'Edit Client',
                            content: html,
                            okButtonText: "Save",
                            afterOpen: function($popup) {
                                //if not active, add delete button
                                if (!$popup.find('#Active').is(':checked')) {
                                    $popup.find('.modal-footer').prepend('<button type="button" class="btn btn-danger float-start">Delete</button>');

                                    //delete handler
                                    $popup.find('.modal-footer').on('click', '.btn-danger', function() {
                                        delta.popup.open({
                                            type: 'confirm',
                                            title: 'Delete Client',
                                            content: 'Are you sure you want to delete this client?  Deletion is irreversible and will remove all reports, packages, and templates!',
                                            css: 'modal-sm',
                                            okButtonText: 'Yes, Delete',
                                            okCallback: function($popup2) {
                                                //add spinner
                                                $popup2.find('.modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');

                                                //call delete
                                                delta.ajax.post(
                                                    '/admin/client/delete?clientID=' + client_id,
                                                    {},
                                                    function() {
                                                        delta.popup.close($popup2);
                                                        delta.popup.close($popup);
                                                        _tbl.ajax.reload();
                                                    }
                                                );

                                                return false;
                                            }
                                        });
                                    });
                                }
                            },
                            okCallback: function($popup) {
                                delta.ajax.post(
                                    '/admin/client/edit',
                                    {
                                        ClientID: $popup.find('#ClientID').val(),
                                        ClientCode: $popup.find('#ClientCode').val(),
                                        ClientName: $popup.find('#ClientName').val(),
                                        Active: $popup.find('#Active').is(':checked')
                                    },
                                    function(json) {
                                        if (json.isValid) {
                                            delta.popup.close($popup);
                                            _tbl.ajax.reload();
                                        } else {
                                            $popup.find('.modal-body').html(json.html);
                                            setTimeout(function() {
                                                delta.popup.enableButtons($popup);
                                            }, 50)
                                        }
                                    }
                                );

                                return false;
                            }
                        });
                    }
                );

                return false;
            });

        },

        dummy = function () { };

    $(document).ready(init);
})();